import { all, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { getLoadData, getSendComment } from '../../../../components/comments/saga';

const api = new Api('jobs/:id/comments');
const loadData = getLoadData(actions, api);
const sendComment = getSendComment(actions, api);

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.SEND_COMMENT, sendComment)]);
}
